
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";

const integrations = [
  {
    name: "SAP S/4HANA",
    logo: "/lovable-uploads/ed0ff682-36c5-4f27-b905-c651675960db.png",
    url: "#"
  },
  {
    name: "Microsoft",
    logo: "/lovable-uploads/903a4546-96a1-4e1f-9281-be0450bc680a.png",
    url: "#"
  },
  {
    name: "SAP Ariba",
    logo: "/lovable-uploads/4f312e1b-7c98-4bb3-b517-74559cdb7260.png",
    url: "#"
  },
  {
    name: "Giblet Connect",
    logo: "/lovable-uploads/e5a14559-5c56-434a-88bf-724fd8af3669.png",
    url: "/ispai-connect-demo"
  }
];

export const IntegrationsMenu = () => {
  const navigate = useNavigate();

  const handleIntegrationClick = (url: string) => {
    if (url === "/ispai-connect-demo") {
      navigate(url);
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Button className="gap-2 bg-black text-white hover:bg-gray-800">
          Integrations <ExternalLink className="h-4 w-4" />
        </Button>
      </HoverCardTrigger>
      <HoverCardContent className="w-80" align="end">
        <div className="grid grid-cols-2 gap-4">
          {integrations.map((integration) => {
            const content = (
              <a
                key={integration.name}
                onClick={() => handleIntegrationClick(integration.url)}
                className={`flex flex-col items-center gap-2 p-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer 
                  ${integration.name === "Giblet Connect" ? "hover:scale-125" : ""}`}
                rel="noopener noreferrer"
              >
                <img
                  src={integration.logo}
                  alt={integration.name}
                  className={`h-10 object-contain 
                    ${integration.name === "Giblet Connect" ? "transition-transform duration-300 hover:scale-125" : ""}`}
                />
                <span className="text-sm font-medium text-gray-700">
                  {integration.name}
                </span>
              </a>
            );

            if (integration.name === "Giblet Connect") {
              return (
                <Tooltip key={integration.name}>
                  <TooltipTrigger asChild>
                    {content}
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Giblet Connect: iSPAI's enterprise browser extension demo</p>
                  </TooltipContent>
                </Tooltip>
              );
            }

            return content;
          })}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
